import { useState, useEffect } from 'react';
import reportService from 'src/services/reports-service';
import { EmbeddedReport } from 'src/models/reports';
import { useAuthContext } from 'src/auth/hooks';

const useReports = () => {
    const { user, authenticated } = useAuthContext();
    const userRoles = user?.roles || [];
    const hasReportsAccess = userRoles.includes('myworkfin.reports.view');
    const [reports, setReports] = useState<EmbeddedReport[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchReports = async () => {
            if (authenticated && hasReportsAccess) {
                try {
                    const data = await reportService.getReports();
                    setReports(data);
                } catch (err) {
                    setError('Failed to fetch reports');
                } finally {
                    setLoading(false);
                }
            }
            else if (authenticated && !hasReportsAccess) {
                setLoading(false);
            }
        };

        fetchReports();
    }, [user, authenticated, hasReportsAccess]);

    return { reports, loading, error };
};

export default useReports;
